import {
  AttributeObjectArrayConfig,
  IngestionConfig,
  NormalizedIngestionSource,
} from './types'

export function useConfigurationFromSource(
  sourceData: NormalizedIngestionSource,
  mergeConfig: IngestionConfig = {},
) {
  const doChildObject = (
    configObj: Record<string, { type: string }>,
    sourceObj: Record<string, unknown>,
  ) => {
    return Object.entries(sourceObj).reduce<AttributeObjectArrayConfig>(
      (acc, [key, value]) => {
        return {
          ...acc,
          [key]: {
            ...acc[key],
            type: typeof value,
          },
        }
      },
      configObj,
    )
  }

  const doObject = (obj: Record<string, unknown>) => {
    const type = String(obj.type)
    const typeConfig = (mergeConfig[type] ??= {
      type,
      attributes: {},
      attrIdOrder: [],
    })
    typeConfig.attrIdOrder ??= []
    Object.entries(obj).forEach(([key, value]) => {
      if (value === undefined || value === null) return
      if (!typeConfig.attrIdOrder.includes(key)) {
        typeConfig.attrIdOrder.push(key)
      }
      if (key === 'type') {
        typeConfig.type = type
      }
      switch (key) {
        case 'children': {
          if (Array.isArray(value)) {
            value.forEach(doObject)
          }
          break
        }
        default: {
          const attrConfig = typeConfig.attributes[key] ?? {}
          attrConfig.key = key
          attrConfig.valueType = Array.isArray(value) ? 'array' : typeof value
          if (attrConfig.valueType === 'object') {
            attrConfig.values = doChildObject(
              attrConfig.values ?? {},
              value as Record<string, unknown>,
            )
          }
          if (
            attrConfig.valueType === 'array' &&
            Array.isArray(value) &&
            value.length
          ) {
            const child = value[0]
            switch (true) {
              case Array.isArray(child): {
                attrConfig.values = {
                  type: `array of arrays`,
                }
                break
              }
              case ['string', 'number'].includes(typeof child): {
                attrConfig.values = {
                  type: `array of ${typeof child}`,
                }
                break
              }
              case typeof child === 'object': {
                attrConfig.values = doChildObject(
                  {},
                  child as Record<string, unknown>,
                )
                break
              }
              default: {
                attrConfig.values = {
                  type: 'array of unknown',
                }
              }
            }
          }
          typeConfig.attributes[key] = attrConfig
        }
      }
    })
  }
  doObject(sourceData)
  return { ...mergeConfig }
}
